var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0ZM20.2197 7.85742C19.7725 7.45993 19.0879 7.50008 18.6904 7.94727L10.7871 16.8369L7.26562 13.3174L7.16406 13.2275C6.73914 12.8971 6.12491 12.927 5.73438 13.3174C5.31131 13.7405 5.31131 14.4265 5.73438 14.8496L10.0674 19.1826L10.166 19.2705C10.6095 19.6182 11.2581 19.5688 11.6426 19.1367L20.3096 9.38672L20.3936 9.2793C20.6984 8.83572 20.6323 8.22436 20.2197 7.85742Z",
    fill: "#00AD3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c71e3c6b76328a999afff82edc56fb3c.svg";
export { ForwardRef as ReactComponent };